import React, { useEffect, useState } from 'react';
import { HeaderBarStyle } from '../../styles';
import { useSelector } from 'react-redux';
import { Col, Row } from 'antd';
import { TextLarge } from '../../../text';
import { ROUTES_PATH } from '../../../../resources/routes-name';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const HeaderLayout = () => {
  const history = useHistory();
  const title = useSelector((state) => state.title.title);
  const profile = useSelector((state) => state.line.profile);
  const [currentTime, setCurrentTime] = useState('');
  function handleProfileClick() {
    const path = ROUTES_PATH.ROUTE_PROFILE.PATH;
    history.push(path);
  }

  useEffect(() => {
    const updateClock = () => {
      const now = new Date();
      const formattedTime = now.toLocaleTimeString('th-TH', { hour12: false });
      const formattedDate = now.toLocaleDateString('th-TH');
      setCurrentTime(`${formattedDate} ${formattedTime}`);
    };
    const interval = setInterval(updateClock, 1000);
    updateClock();

    return () => clearInterval(interval);
  }, []);
  return (
    <HeaderBarStyle>
      <div
        style={{
          position: 'fixed',
          top: '-10px',
          left: '20px',
          color: 'white',
          fontSize: '12px',
          zIndex: 1000,
        }}
      >
        {currentTime}
      </div>
      <Row justify="center" align="middle" style={{ height: '100%', marginTop: '-50px' }}>
        {/* คอลัมน์สำหรับชื่อ Header */}
        <Col span={20} style={{ textAlign: 'center', paddingLeft: '50px' }}>
          <TextLarge text={title} style={{ color: 'white' }} />
        </Col>

        {/* คอลัมน์สำหรับรูปโปรไฟล์ */}
        <Col span={4} style={{ textAlign: 'right', paddingRight: '20px' }}>
          {profile?.pictureUrl && (
            <img
              src={profile?.pictureUrl}
              alt="Profile"
              width="40"
              height="40"
              onClick={handleProfileClick}
              style={{ borderRadius: '50%', cursor: 'pointer' }}
            />
          )}
        </Col>
      </Row>
    </HeaderBarStyle>
  );
};

export default HeaderLayout;
